import { useMemo } from 'react';
import {
	COMPANY_MANAGED_PROJECT,
	CORE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
	TEAM_MANAGED_PROJECT,
} from '@atlassian/jira-common-constants';
import { useIntl } from '@atlassian/jira-intl';

import { templatesJSW } from '../../../common/constants/steps';
import type { ProjectData } from '../../../common/types';
import messages from './messages';

export const useContent = (projectData: ProjectData) => {
	const { formatMessage } = useIntl();
	const projectTypeDisplayNames = useMemo(
		() => ({
			[CORE_PROJECT]: formatMessage(messages.business),
			[SOFTWARE_PROJECT]: formatMessage(messages.software),
			[SERVICE_DESK_PROJECT]: '',
			[PRODUCT_DISCOVERY_PROJECT]: '',
		}),
		[formatMessage],
	);

	const projectStyleDisplayNames = useMemo(
		() => ({
			[COMPANY_MANAGED_PROJECT]: formatMessage(messages.cmp),
			[TEAM_MANAGED_PROJECT]: formatMessage(messages.tmp),
		}),
		[formatMessage],
	);

	const projectTypeDisplayName = projectData.type ? projectTypeDisplayNames[projectData.type] : '';
	const projectStyleDisplayName = projectData.style
		? projectStyleDisplayNames[projectData.style]
		: '';

	const selectedTemplate = projectData.template
		? templatesJSW.find((template) => template.key === projectData.template)
		: null;

	return {
		projectType: projectTypeDisplayName,
		projectStyle: projectStyleDisplayName,
		projectTemplate: selectedTemplate ? ` (${formatMessage(selectedTemplate.title)})` : '',
	};
};
